import React, { useEffect, useRef, useState } from "react";
import {
  EditCategoryProductSlice,
  GetProductCategorySlice,
} from "../../../redux/features/ProductCategorySlice";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { onImageHandler } from "../../../components/UploadImageOnBucket";
import { toast } from "react-toastify";

const EditCategory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const AnchorRef = useRef(null);

  const [image, setImage] = useState("");

  const [data, setData] = useState({
    categoryName: "",
    categoryImage: null,
    isActive: true,
  });

  useEffect(() => {
    setData({
      categoryName: state?.categoryName || "",
      categoryImage: state?.categoryImage || null,
      isActive: state?.isActive ?? true,
    });
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Toggle isActive
  const handleToggle = () => {
    setData((prevState) => ({
      ...prevState,
      isActive: !prevState.isActive,
    }));
  };

  const handleFileChange = async (e) => {
    const { name } = e.target;

    try {
      const imageData = await onImageHandler(e);

      setData((prevState) => ({
        ...prevState,
        [name]: imageData[1]?.location,
      }));
    } catch (error) {
      toast.error("Something went wrong with AWS bucket");
    }
  };

  const handleSubmit = () => {
    if (!data.categoryName?.trim() || !data.categoryImage) {
      toast.error("Please fill the details!");
      return;
    }

    const formData = new FormData();

    formData.append("categoryName", data.categoryName);
    formData.append("categoryImage", data.categoryImage);
    formData.append("isActive", data.isActive);

    console.log("data:", data);

    dispatch(EditCategoryProductSlice({ id, formData })).then((res) => {
      AnchorRef.current.click();
    });

    setData({
      categoryName: "",
      categoryImage: null,
      isActive: true,
    });

    setImage("");
  };

  const handleNavigate = () => {
    navigate(-1);
  };

  return (
    <div className="ModalBox">
      <div
        id="NotificationEdit"
        className="modal fade"
        role="dialog"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="Category">
                <a
                  ref={AnchorRef}
                  href="javascript:void(0);"
                  className="CloseModal"
                  data-dismiss="modal"
                  onClick={handleNavigate}
                >
                  ×
                </a>

                <h3>Edit Category</h3>

                {/* Category Name */}
                <div className="form-group">
                  <label>Category Name</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter category name"
                    name="categoryName"
                    value={data.categoryName}
                    onChange={handleChange}
                  />
                </div>

                {/* Category Image */}
                <div className="form-group">
                  <label>Upload Images</label>

                  {data?.categoryImage && (
                    <img
                      src={data.categoryImage}
                      style={{
                        height: "100px",
                        width: "160px",
                        marginBottom: "10px",
                      }}
                      alt="Category Preview"
                    />
                  )}

                  <div className="UploadBox">
                    <div className="Upload">
                      <i className="fa fa-upload" />
                      <span>Upload</span>

                      <input
                        type="file"
                        name="categoryImage"
                        accept=".jpg,.png,.jpeg"
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Active Toggle */}
                <div className="form-group">
                  <label>Category Status</label>

                  <div
                    onClick={handleToggle}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        width: "50px",
                        height: "26px",
                        borderRadius: "20px",
                        backgroundColor: data.isActive
                          ? "#28a745"
                          : "#ccc",
                        position: "relative",
                        transition: "0.3s",
                      }}
                    >
                      <div
                        style={{
                          width: "22px",
                          height: "22px",
                          borderRadius: "50%",
                          backgroundColor: "#fff",
                          position: "absolute",
                          top: "2px",
                          left: data.isActive ? "26px" : "2px",
                          transition: "0.3s",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                        }}
                      />
                    </div>

                    <span>
                      {data.isActive ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>

                {/* Save */}
                <a
                  href="javascript:void(0);"
                  className="Button"
                  onClick={handleSubmit}
                >
                  Save
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCategory;
